import React from 'react';
import { openCustomerPortal } from '../utils/cn';

function MobileEstimateFAB() {
  const handleClick = (e) => {
    e?.preventDefault();
    console.log('[MobileEstimateFAB] 🖱 "Get Instant Estimate" FAB button clicked');
    openCustomerPortal();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-100 shadow-lg px-4 py-3">
      <button
        id="diq-journey-9674cf04-4057-4e53-acbb-533aa94307ea"
        onClick={handleClick}
        className="w-full py-4 text-white font-bold text-lg tracking-wide shadow-lg rounded-md"
        style={{ backgroundColor: '#07b0e9' }}
      >
        Get Roof Price
      </button>
    </div>
  );
}

export default MobileEstimateFAB;